import PropTypes from 'prop-types';
import React, { useContext } from 'react';
import { Button } from '@sm/wds-react';
import ThemeContext from '~app/components/Survey/ThemeContext';
import checkDarkMode from '~app/helpers/luminance';
import './action-group.scss';

const ActionGroup = ({ qrDoneUrl }) => {
  const themeCtx = useContext(ThemeContext);
  const backgroundColor = themeCtx.common?.backgroundColor || '#fff';
  const acBtnColor = checkDarkMode(backgroundColor) ? 'black' : 'primary';

  return (
    <div className="sm-action-group--container">
      <div className="sm-action-group--cta">
        <Button size="lg" color={acBtnColor} href={qrDoneUrl}>
          Done
        </Button>
      </div>
    </div>
  );
};

ActionGroup.propTypes = {
  qrDoneUrl: PropTypes.string.isRequired,
};

export default ActionGroup;
